export const CONTACT_EMAIL = "elbadriarchitects@yahoo.com";

export const SERVICES = [
  {
    id: "architecture",
    code: "A-01",
    title: "Architectural design",
    short: "Concept, planning and technical drawings shaped around buildability and cost.",
    text: "We think about how a building goes together while the design is still on paper. From measured surveys and concept options to planning drawings and building-regulations packages, the design stays connected to what happens on site.",
    points: ["Measured surveys", "Concept & planning drawings", "Building regulations packages", "Design coordination"],
    img: "/img/drafting.jpg",
  },
  {
    id: "extensions",
    code: "B-02",
    title: "Extensions",
    short: "Single and double-storey extensions that feel like they were always there.",
    text: "Rear, side and wrap-around extensions planned in the right sequence, from groundworks and steelwork to the final finish, with clear communication throughout.",
    points: ["Rear & side returns", "Wrap-around extensions", "Steelwork & structure", "Open-plan kitchens"],
    img: "/img/extension.jpg",
  },
  {
    id: "lofts",
    code: "B-03",
    title: "Loft conversions",
    short: "Turning unused roof space into bedrooms, studios and suites.",
    text: "Dormer, hip-to-gable and Velux conversions, designed for headroom and light, and built with careful attention to structure, insulation and stairs.",
    points: ["Dormer conversions", "Hip-to-gable", "Rooflight conversions", "Staircase design"],
    img: "/img/loft.jpg",
  },
  {
    id: "refurbishment",
    code: "B-04",
    title: "Refurbishment",
    short: "Whole-home and commercial refurbishment, first fix to final finish.",
    text: "Strip-outs, reconfiguration and complete refurbishments for homes and commercial spaces, managed with a realistic programme and clear accountability.",
    points: ["Whole-home renovation", "Commercial fit-out", "Reconfiguration", "Structural alterations"],
    img: "/img/renovation.jpg",
  },
  {
    id: "interiors",
    code: "C-05",
    title: "Interior construction & finishing",
    short: "Joinery, kitchens, flooring and finishes — the details people touch.",
    text: "The inside of the box: partitions, ceilings, kitchens, bathrooms, staircases, flooring and decoration, delivered with the precision that makes a space feel considered.",
    points: ["Kitchens & bathrooms", "Joinery & staircases", "Flooring", "Plastering & decoration"],
    img: "/img/kitchen.jpg",
  },
  {
    id: "conservatories",
    code: "B-06",
    title: "Conservatories & garden rooms",
    short: "Light-filled spaces that connect the house to the garden.",
    text: "Conservatories, orangeries and garden rooms designed to be usable all year, with proper foundations, insulation and glazing.",
    points: ["Orangeries", "Garden rooms", "Glazed links", "Roof replacements"],
    img: "/img/living.jpg",
  },
  {
    id: "design-build",
    code: "D-07",
    title: "Design & Build",
    short: "One team from the first sketch to the finished building.",
    text: "Our direction: design, construction and project management delivered as one integrated service, so you deal with one team that is accountable for the whole result.",
    points: ["Single point of contact", "Integrated programme", "Cost control", "Handover & aftercare"],
    img: "/img/facade.jpg",
  },
];

export const PROJECTS = [
  { id: 1, title: "Open-plan kitchen extension", category: "Extensions", place: "North West", img: "/img/kitchen.jpg", span: "lg:col-span-7" },
  { id: 2, title: "Contemporary living room", category: "Interiors", place: "Lancashire", img: "/img/lounge.jpg", span: "lg:col-span-5" },
  { id: 3, title: "Feature staircase", category: "Interiors", place: "North West", img: "/img/stair.jpg", span: "lg:col-span-5" },
  { id: 4, title: "Modern facade concept", category: "Architecture", place: "North West", img: "/img/facade.jpg", span: "lg:col-span-7" },
  { id: 5, title: "Marble kitchen finish", category: "Interiors", place: "Lancashire", img: "/img/marble.jpg", span: "lg:col-span-6" },
  { id: 6, title: "Loft conversion", category: "Lofts", place: "North West", img: "/img/loft.jpg", span: "lg:col-span-6" },
  { id: 7, title: "Rear extension build", category: "Extensions", place: "Lancashire", img: "/img/extension.jpg", span: "lg:col-span-4" },
  { id: 8, title: "Whole-house refurbishment", category: "Refurbishment", place: "North West", img: "/img/renovation.jpg", span: "lg:col-span-4" },
  { id: 9, title: "Lounge reading corner", category: "Interiors", place: "Lancashire", img: "/img/chair.jpg", span: "lg:col-span-4" },
];

export const PRINCIPLES = [
  { n: "01", title: "Design intelligently", text: "We think about buildability and cost while a design is still on paper. Early design coordination prevents problems on site.", img: "/img/plans.jpg" },
  { n: "02", title: "Build properly", text: "Quality comes from preparation and the right sequence of work. Site management and health and safety are part of the job, not an afterthought.", img: "/img/extension.jpg" },
  { n: "03", title: "Deliver professionally", text: "Clear communication, a realistic programme and clear accountability from the first conversation to handover.", img: "/img/living.jpg" },
];

export const MARQUEE = ["Architecture", "Extensions", "Loft conversions", "Refurbishment", "Interiors", "Design & Build"];
